import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomerContactTypeComponent} from './customer-contact-type.component';


@NgModule({
  declarations: [CustomerContactTypeComponent],
  exports: [CustomerContactTypeComponent],
  imports: [
    CommonModule,
  ],
})
export class CustomerContactTypeModule {
}
